<template>
  <div class="aw" :class="[`aw--${layout}`, `aw--${align}`]">
    <p v-if="!actions.length" class="ov-empty">{{ $t('dash.overview.widgets.actions_empty') }}</p>
    <button
      v-for="action in actions"
      :key="action.key"
      class="ov-action ov-aw-btn"
      :class="{ 'ov-action--primary': action.primary }"
      @click="$emit('action', action)"
    >
      <i class="material-icons">{{ action.icon }}</i>
      <span>{{ action.label }}</span>
      <span v-if="action.badge" class="ov-action-badge">{{ action.badge > 99 ? '99+' : action.badge }}</span>
    </button>
  </div>
</template>

<script>
/**
 * Boutons d'action (créer une publication, planner, Inbox, Reporting…) ; actions et droits calculés par le tableau de bord
 */
export default {
  name: 'ActionsWidget',

  props: {
    actions: { type: Array, default: () => [] },
    // row : boutons en ligne ; grid : tuiles réparties sur la largeur
    layout: { type: String, default: 'row' },
    // Alignement horizontal des boutons (ligne) : left | center | right
    align: { type: String, default: 'center' }
  }
}
</script>

<style scoped>
/* Centrés verticalement dans la carte (avec ou sans titre) */
.aw {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  align-content: center;
  gap: 8px;
  height: 100%;
}
.aw--left { justify-content: flex-start; }
.aw--center { justify-content: center; }
.aw--right { justify-content: flex-end; }
.aw--grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
}
.aw--grid .ov-aw-btn {
  justify-content: center;
}
</style>
